"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.styles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("../styles"));
var _tokens = require("../styles/tokens");
var _excluded = ["classes", "inputProps"];
var styles = exports.styles = function styles(theme) {
  return {
    root: {
      color: theme.palette.grey['500'],
      margin: _tokens.spacing40,
      padding: 0,
      width: _tokens.sizingMedium // size of the icon
    },
    focused: {
      borderRadius: _tokens.borderRadiusSmall,
      boxShadow: "inset 0 0 0 2px " + _tokens.colorBrandSecondary,
      color: theme.palette.grey['500'],
      margin: _tokens.spacing40,
      padding: 0,
      width: _tokens.sizingMedium // size of the icon
    },
    checked: {},
    disabled: {},
    indeterminate: {},
    colorPrimary: {
      '&$checked': {
        color: theme.palette.ctaColor.base
      },
      '&$indeterminate': {
        color: theme.palette.grey['500']
      },
      '&$disabled': {
        color: theme.palette.disabled.background
      }
    }
  };
};

/**
 * Use `Checkbox` to allow a user to select one or more values from a small set of options.
 * @done true
 * @updated v7.11.0
 * @versionAdded v0.0.5
 * @examples
 *  LabeledCheckboxes
 *  UnlabeledCheckboxes
 */
var Checkbox = /*#__PURE__*/function (_React$Component) {
  function Checkbox(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      isFocused: false
    };
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    return _this;
  }
  (0, _inheritsLoose2.default)(Checkbox, _React$Component);
  var _proto = Checkbox.prototype;
  _proto.handleFocus = function handleFocus(e) {
    if (this.props.onFocus) {
      this.props.onFocus(e);
    }
    this.setState(function () {
      return {
        isFocused: true
      };
    });
  };
  _proto.handleBlur = function handleBlur(e) {
    if (this.props.onBlur) {
      this.props.onBlur(e);
    }
    this.setState(function () {
      return {
        isFocused: false
      };
    });
  };
  _proto.render = function render() {
    var isFocused = this.state.isFocused;
    var _this$props = this.props,
      classes = _this$props.classes,
      inputPropsTemp = _this$props.inputProps,
      other = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
    var inputProps = (0, _extends2.default)({}, inputPropsTemp);
    return /*#__PURE__*/_react.default.createElement(_Checkbox.default, (0, _extends2.default)({
      classes: {
        root: isFocused ? classes.focused : classes.root,
        checked: classes.checked,
        indeterminate: classes.indeterminate,
        disabled: classes.disabled,
        colorPrimary: classes.colorPrimary
      },
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      disableRipple: true,
      inputProps: inputProps
    }, other));
  };
  return Checkbox;
}(_react.default.Component);
Checkbox.muiName = 'Checkbox';
Checkbox.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes.default.object,
  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,
  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes.default.node,
  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,
  /**
   * If `true`, the component appears indeterminate.
   */
  indeterminate: _propTypes.default.bool,
  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: _propTypes.default.node,
  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes.default.object,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.any
  })]),
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,
  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,
  /**
   * 	The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object]),
  /**
   * The input component property `type`.
   */
  type: _propTypes.default.string,
  /**
   * The value of the component.
   */
  value: _propTypes.default.string
};
Checkbox.defaultProps = {
  indeterminate: false
};
var _default = exports.default = (0, _styles.default)(styles)(Checkbox);